"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PetsSummary = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _summaryKeyValuePair = require("../SummaryKeyValuePair/summaryKeyValuePair");
var _brandContext = require("../../../contextProviders/brandContext");
var _selectors = require("../../../store/quote/selectors");
var _coverDetailsSummary = require("../CoverDetailsSummary/coverDetailsSummary");
var _QuoteHeading = require("../../Layout/QuoteHeading");
var _steps = require("../../../constants/app/steps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PetsSummary = exports.PetsSummary = function PetsSummary() {
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    _useContext$activeBra = _useContext.activeBrandContext.steps,
    _useContext$activeBra2 = _useContext$activeBra.summary.petSummary,
    _useContext$activeBra3 = _useContext$activeBra2.heading,
    headingLabel = _useContext$activeBra3.label,
    panelIconFunction = _useContext$activeBra3.icon,
    allowEdit = _useContext$activeBra2.allowEdit,
    _useContext$activeBra4 = _useContext$activeBra2.petInfoSection,
    infoPetSummaryLabels = _useContext$activeBra4.labels,
    formatters = _useContext$activeBra4.formatters,
    stepDefinitions = _useContext$activeBra.StepDefinitions;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    savedQuote = _useSelector.quote;
  var handleEdit = function handleEdit(step) {
    navigate("/".concat(step));
  };
  var petNames = (0, _react.useMemo)(function () {
    var names = savedQuote.pets.map(function (pet) {
      return pet.petName;
    });
    if ((names === null || names === void 0 ? void 0 : names.length) === 1) return names[0];
    return "".concat(names[0], " and ").concat(names.slice(1, names.length).join(', '));
  }, [savedQuote.pets]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "summarySection petsSummary"
  }, /*#__PURE__*/_react["default"].createElement(_QuoteHeading.QuoteToolHeading, {
    headingText: headingLabel,
    showMandatoryText: false,
    customCssClass: "sectionTitle"
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: "summaryPanel policySummary"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "policyDate"
  }, "Your ", savedQuote.pets.length > 1 ? 'policies' : 'policy', " for\xA0", petNames, " will begin at ", /*#__PURE__*/_react["default"].createElement("b", null, "11:59PM"), " on\xA0", /*#__PURE__*/_react["default"].createElement("b", null, (0, _dayjs["default"])(savedQuote.policyStartDate).format('MMM DD, YYYY'))), allowEdit && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "button text_only editBtn",
    onClick: function onClick() {
      return handleEdit("".concat(stepDefinitions.find(function (step) {
        return step.id === _steps.StepIndex.coverOptions;
      }).url));
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "pencil"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Edit")))), savedQuote.pets.map(function (pet) {
    var species = pet.species,
      petName = pet.petName;
    return /*#__PURE__*/_react["default"].createElement("section", {
      key: "petSummary_".concat(petName),
      className: "summaryPanel"
    }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("h3", null, panelIconFunction(species), " ", petName)), /*#__PURE__*/_react["default"].createElement("main", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "summaryKeyValuePair"
    }, /*#__PURE__*/_react["default"].createElement("b", null, "Basic information"), allowEdit && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "button text_only editBtn",
      onClick: function onClick() {
        return handleEdit("".concat(stepDefinitions.find(function (step) {
          return step.id === _steps.StepIndex.youAndYourPets;
        }).url));
      }
    }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "pencil"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "labelText petSummary"
    }, "Edit"))), Object.entries(infoPetSummaryLabels).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        label = _ref2[1];
      var formatter = formatters[key] || null;
      return /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
        key: key,
        label: label,
        value: pet[key],
        formatter: formatter
      });
    }), !!pet && !!pet.selectedQuote && /*#__PURE__*/_react["default"].createElement(_coverDetailsSummary.CoverDetailsSummary, {
      key: "coverDetailsSummary_".concat(petName),
      pet: pet
    })));
  }));
};